/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createAdDesignDataSchema = z.object({
	name: z.string(),
	document: z.string(),
	thumbnailMediaId: z.string().uuid().nullable().optional(),
})

export type CreateAdDesignDataSchema = z.infer<typeof createAdDesignDataSchema>
